import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Input, message, Modal } from 'antd';
import useDeleteBox from '@/common/components/deleteBox.js';

import { adartsCardListHttp, adartsCardDeleteHttp, adartsCardCopyHttp, adartsBindHttp, adartsMainCardHttp } from '@/api';
import { MD5 } from '@/common/Utlis';

import adartsCard from '@/assets/img/adartsCard.png';
import A from '@/assets/img/Adarts.png';
import L from '@/assets/img/League.png';

const AdartsCardSetting = () => {
  const { t } = useTranslation();
  const { show, CustomModal } = useDeleteBox();
  const [cardList, setCardList] = useState([]);
  const [cardNo, setCardNo] = useState('');
  const [cardId, setCardId] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [cardNoNew, setCardNoNew] = useState('');
  const [password, setPassword] = useState('');
  const memberId = sessionStorage.getItem('websiteMemberId');
  const handleDeleteBtn = (cardId) => {
    setCardId(cardId);
    show();
  }
  const getCardList = () => {
    adartsCardListHttp({ memberId }).then(res => {
      if (res.data.code === 100) {
        setCardList(res.data.data)
      }
    })
  };
  const handleSetMainCard = (cardId) => {
    adartsMainCardHttp({ cardId, memberId }).then(res => {
      if (res.data.code === 100) {
        message.info(res.data.msg)
        sessionStorage.setItem('websiteCardId', cardId)
        getCardList();
      }
    })
  }
  const handleAddCrad = () => {
    adartsBindHttp({ cardNo, memberId }).then(res => {
      if (res.data.code === 100) {
        message.info(res.data.msg)
        getCardList()
      } else {
        message.warning(res.data.msg)
      }
    })
  }
  const handleOk = () => {
    if (cardNoNew && password) {
      adartsCardCopyHttp({ cardNoOld: cardId, cardNoNew, password: MD5(password) }).then(res => {
        if (res.data.code === 100) {
          message.warning(res.data.msg);
          setModalVisible(false);
          setCardNoNew('');
          setPassword('');
          getCardList();
        } else {
          message.warning(res.data.msg);
        }
      })
    } else {
      message.warning(t(63))
    }
  }
  const handleBtnClick = (bool) => {
    if (bool) {
      adartsCardDeleteHttp({ cardId }).then(res => {
        if (res.data.code === 100) {
          message.info(res.data.msg)
          getCardList();
        }
      })
    }
  }
  const handleCoptBtnClick = (bool, id) => {
    setModalVisible(bool);
    setCardId(id);
  }
  useEffect(() => {
    getCardList()
    return () => setCardList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div>
      <div className='myPageTitle' id='AdartsCardSetting'>{t(69)}</div>
      {cardList.map(i => {
        return (
          <div key={i.cardId} className='AdartsCardBox'>
            <div className='AdartsCardImg'>
              <div className='AdartsCardImgBox'><img src={adartsCard} alt="" /></div>
              <div className='AdartsCardUserName'>{i.name}</div>
            </div>
            <div className='AdartsCardInfoBox'>
              <div className='AdartsCardInfo'>
                <div className='AdartsCardIconBox'>{i.cardType === 1 ? <img src={A} alt="" /> : <img src={L} alt="" />}</div>
                <div>{t(35)}：{i.cardNo}</div>
              </div>
              <div className='AdartsCardLine'></div>
              <div className='AdartsCardResultBox'>
                <div>{`Rating  ${i.rating}`}</div>
                <div>{`PPD  ${i.ppd}`}</div>
                <div>{`MPR  ${i.mpr}`}</div>
              </div>
            </div>
            <div className='AdartsCardBtnBox'>
              {!i.isMainCard ? <Button type="primary" onClick={() => handleSetMainCard(i.cardId)}>{t(144)}</Button> : t(161)}
              <Button type="primary" onClick={() => handleCoptBtnClick(true, i.cardNo)}>{t(96)}</Button>
              {!i.isMainCard ? <Button type="primary" danger onClick={() => handleDeleteBtn(i.cardId)}>{t(97)}</Button> : null}
            </div>
          </div>
        )
      })}
      {cardList.length < 3 ?
        <div className='AdartsCardAddBox'>
          <div className='AdartsCardName'>{t(35)}：</div>
          <div className='AdartsCardAddCard'><Input onChange={(e) => setCardNo(e.target.value)} /></div>
          <div className='AdartsCardBtnBox'><Button type="primary" onClick={handleAddCrad}>{t(98)}</Button></div>
        </div>
        : ''}
      {/* 删除弹框 */}
      <CustomModal handleBtnClick={handleBtnClick} />
      {/* 卡复制弹框 */}
      <Modal title={t(96)} footer={null} className='copybox' width='40%' centered visible={modalVisible} onCancel={() => setModalVisible(false)}>
        <h2>{t(238)}</h2>
        <div className='copyDialog'>
          <div>{t(35)}：</div>
          <div><Input placeholder={t(237)} onChange={(e) => setCardNoNew(e.target.value)} /></div>
        </div>
        <div className='copyDialog'>
          <div>{t(27)}：</div>
          <div><Input type='password' onChange={(e) => setPassword(e.target.value)} /></div>
        </div>
        <div className='countryLanguageSelect'>
          <Button type="primary" onClick={() => handleOk()}>{t(19)}</Button>
          <Button onClick={() => setModalVisible(false)}>{t(127)}</Button>
        </div>
      </Modal>
    </div>
  )
}
export default AdartsCardSetting